import { createFileRoute } from "@tanstack/react-router";
import CodeFormatterPage from "@/pages/CodeFormatterPage";

export const Route = createFileRoute("/tools/code-formatter")({
  component: CodeFormatterPage,
});
